const dropdownNavLinks = document.querySelectorAll("a[data-click-section='dropdown_nav_offers']")

dropdownNavLinks.forEach((link) => {
    let href = link.getAttribute("href")
    const hrefElements = href.split("/")
    const slug = hrefElements[hrefElements.length - 2]

    let urlChar = "?"
    if (hrefElements[hrefElements.length - 1].indexOf("?") === 0) {
        urlChar = "&"
    }

    const updatedHref = href + urlChar + "ftm_cam=ascent-pages&ftm_veh=nav_offers&ftm_pit=" + slug

    link.setAttribute("href", updatedHref)
})
